import { createGlobalStyle } from 'styled-components';
import { normalize, darken } from 'polished';

import breakpoints from './breakpoints';

const GlobalStyles = createGlobalStyle`
  ${normalize()}

  html {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-size: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  :focus {
    outline-width: 1px;
    outline-color: #fd5f00;
  }

  body {
    font-family: ${p => p.theme.fontFamily};
    font-size: 1rem;
    letter-spacing: ${p => p.theme.letterSpace};
    margin: 0;
    padding: 0;
  }

  h1 {
    color: ${p => p.theme.colors.darkFont};
    font-size: ${p => p.theme.sizes.h1};
    font-weight: ${p => p.theme.weights.bold};
    letter-spacing: 0.6px;
    line-height: 1.2;
    margin: 0 0 50px 0;
  }

  h2 {
    color: ${p => p.theme.colors.darkFont};
    font-size: ${p => p.theme.sizes.h2.small};
    font-weight: ${p => p.theme.weights.bold};
    letter-spacing: 0.3px;
    line-height: 1.6;
    margin: 0 0 23px 0;

    ${breakpoints.medium`
      font-size: ${p => p.theme.sizes.h2.medium};
    `};

    ${breakpoints.large`
      font-size: ${p => p.theme.sizes.h2.large};
    `};
  }

  h3 {
    color: ${p => p.theme.colors.darkFont};
    font-size: ${p => p.theme.sizes.h3};
    font-weight: ${p => p.theme.weights.bold};
    line-height: 1.1;
    letter-spacing: 0.2px;
    margin: 0 0 10px 0;

    ${breakpoints.medium`
      font-size: ${p => p.theme.sizes.h3.medium};
    `}

    ${breakpoints.large`
      font-size: ${p => p.theme.sizes.h3.large};
    `}
  }

  p {
    font-size: ${p => p.theme.sizes.p.small};
    font-weight: ${p => p.theme.weights.normal};
    line-height: 1.6;
    margin: 0 0 30px 0;

    ${breakpoints.medium`
      font-size: ${p => p.theme.sizes.p.medium};
      margin: 0 0 40px 0;
    `}

    ${breakpoints.large`
      font-size: ${p => p.theme.sizes.p.large};
      margin: 0 0 40px 0;
    `}
  }

  strong {
    font-weight: ${p => p.theme.weights.bold};
  }

  small {
    font-size: ${p => p.theme.sizes.small};
    font-style: italic;
    font-weight: ${p => p.theme.weights.normal};
    line-height: 1.38;
  }

  a {
    color: ${p => p.theme.colors.primary};
    transition: 0.5s color;
  }

  a:hover {
    color: ${p => darken(0.2, p.theme.colors.primary)};
  }

  ul,ol {
    font-size: ${p => p.theme.sizes.p.small};
    margin: 0 0 40px 0;

    ${breakpoints.medium`
      font-size: ${p => p.theme.sizes.p.medium};
    `}

    ${breakpoints.large`
      font-size: ${p => p.theme.sizes.p.large};
    `}
  }

  table {
    border-spacing: 10px;
    border-collapse: separate;
    font-size: ${p => p.theme.sizes.p.small};
    margin: 0 0 40px 0;
    width: 100%;

    ${breakpoints.medium`
      font-size: ${p => p.theme.sizes.p.medium};
    `}

    ${breakpoints.large`
      font-size: ${p => p.theme.sizes.p.large};
    `}
  }

  th {
    border-bottom: 1px solid ${p => p.theme.colors.primary};
    color: ${p => p.theme.colors.lightFont};
    font-size: 1.125rem;
    font-weight: ${p => p.theme.weights.bold};;
    line-height: 1.22;
    letter-spacing: 0.2px;
    text-align: left;
    padding: 10px 0;
    vertical-align: baseline;
  }

  td {
    border-bottom: 1px solid ${p => p.theme.colors.border};
    line-height: 1.67;
    padding: 10px 0;
    vertical-align: baseline;
  }

  td > p {
    margin-bottom: 20px;
  }

  blockquote {
    border-left: 2px solid ${p => p.theme.colors.primary};
    font-size: 1.5625rem;
    margin: 0 0 40px 0;
    padding: 20px;

    footer {
        font-size: 0.75rem;
    }
  }

  iframe {
    max-width: 100%;
  }

  img {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
  }

  figure {
    margin: 0;
    max-width: 100%;
  }

  figcaption {
    font-size: 0.75rem;
    margin-bottom: 40px;
  }

  .alignleft {
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .alignright {
    float: right;
    margin-left: 20px;
    margin-bottom: 20px;
  }

  .aligncenter {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }

  .fade {
    opacity: 0;
  }

  .fade-enter-done {
    opacity: 1;
  }

  .fade-enter {
    opacity: 0.01;
    z-index: 9999;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit.fade-exit-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }
	.slick-prev:before,
	.slick-next:before {
  color: #000000!important;
}
`;

export default GlobalStyles;
